export const NAV_SECTION_HEIGHT = 50; // pixels
